import { Collection } from '@/kernel/collection';

import StringCell from '@/components/cells/string-cell.vue';
import DateCell from '@/components/cells/date-cell.vue';
import BooleanCell from '@/components/cells/boolean-cell.vue';
import EditCollectionCell from '@/components/cells/edit-collection-cell.vue';

import { DateRangeFilterAdapter, SelectFilterAdapter, MultipleRelationInputAdapter } from '@/kernel/adapters';

import DateRangeInput from '@/components/inputs/date-range-input.vue';
import TextInput from '@/components/inputs/text-input.vue';
import TextareaInput from '@/components/inputs/textarea-input.vue';
import CheckboxInput from '@/components/inputs/checkbox-input.vue';
import SelectInput from '@/components/inputs/select-input.vue';
import MultipleRelationInput from '@/components/inputs/multiple-relation-input.vue';

export class Theme extends Collection {
  config = {
    autoRoute: true,
    requiresSuperAdmin: true,
    key: 'theme',
    pluralLabel: 'Themes',
    singleLabel: 'Theme',
    indexUrl: '/theme',
    createUrl: '/theme/create',
    searchKeys: ['name'],
    editUrlPrefix: '/theme',
    idKey: 'id',
    nameKey: 'name',
    payloadEndpoint: '/theme',
    defaultSort: {
      key: 'name',
      order: 1
    },
    indexColumns: [
      {name: 'Actions', key: 'edit', sortable: false, cell: EditCollectionCell, props: {collection: 'theme'}},
      {name: 'Name', key: 'name', sortable: true, cell: StringCell},
      {name: 'Updated', key: 'updatedAt', sortable: true, cell: DateCell},
      {name: 'Created', key: 'createdAt', sortable: true, cell: DateCell}
    ],
    indexFilters: [
      {key: 'updatedAt', label: 'Updated at', input: DateRangeInput, adapter: DateRangeFilterAdapter, props: {label: 'Updated at'}},
      {key: 'createdAt', label: 'Created at', input: DateRangeInput, adapter: DateRangeFilterAdapter, props: {label: 'Created at'}}
    ],
    createFormFields: [
      {key: 'name', label: 'Name', input: TextInput, props: {label: 'Name'}},
      {key: 'code', label: 'Code', input: TextInput, props: {label: 'Code'}}
    ],
    editFormFields: [
      {key: 'name', label: 'Name', input: TextInput, props: {label: 'Name'}},
      {key: 'code', label: 'Code', input: TextInput, props: {label: 'Code'}}
    ]
  }
}